/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsDatabaseDestination } from '../models/AwsDatabaseDestination';

/**
* Restore configuration.
*/
export class DatabaseDestination {
  'awsRds'?: AwsDatabaseDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "awsRds",
      "baseName": "awsRds",
      "type": "AwsDatabaseDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DatabaseDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

